export const NUMBER_OF_REPORTS_IN_CAROUSEL = 3;